<!-- =========================================================================================
  File Name: CustomerDebtListFormSidebar.vue
  Description: Add New Data - Sidebar component
========================================================================================== -->
<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide =>
				handleCloseDialog(() => {
					initValues();
					setDialogHide();
				}, isFormDirty)
		"
		class="custom-dialog todo-list-form-sidebar"
		:visible.sync="isSidebarActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Thông tin khám bệnh</h4>
			<p class="text-base text-black font-medium">{{ data ? data.name : "" }}</p>
		</div>
		<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div>
				<div style="display: none;">
					<cbs-input readonly
						dataType="text"
						class="vs-inputx vs-input--input normal w-full"
						v-model="id"
						name="id"
						:userSetting="userSettings"
						:data-vv-as="'Số Passport'"
						:placeholder="'Nhập Số Passport'"
					/>
				</div>

				<!-- thong tin chuyen di -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">THÔNG TIN CHUYẾN ĐI</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Mã chuyến đi:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="tt_chuyen_di_ma"
										name="tt_chuyen_di_ma"
										:userSetting="userSettings"
										:data-vv-as="'Mã chuyến đi'"
										:placeholder="'Nhập Mã chuyến đi'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Ngày đi:</label>
									<cbs-date-picker readonly
										clearable
										class="w-full"
										type="date"
										name="tt_chuyen_di_ngay_di"
										prefix-icon="''"
										ref="tt_chuyen_di_ngay_di"
										format="DD-MM-yyyy"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="'Ngày đi'"
										:placeholder="'Ngày đi'"
										v-model="tt_chuyen_di_ngay_di"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Ngày về:</label>
									<cbs-date-picker readonly
										clearable
										class="w-full"
										type="date"
										name="tt_chuyen_di_ngay_ve"
										prefix-icon="''"
										ref="tt_chuyen_di_ngay_ve"
										format="DD-MM-yyyy"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="'Ngày về'"
										:placeholder="'Ngày về'"
										v-model="tt_chuyen_di_ngay_ve"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="tt_chuyen_di_lich_trinh_images" class="vs-input--label directive--label">Lịch trình:</label>
									<cbs-upload-ref :isEditable="false" v-model="tt_chuyen_di_lich_trinh_images" name="tt_chuyen_di_lich_trinh_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Đơn vị tổ chức tour:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="tt_chuyen_di_dv_to_chuc_tour"
										name="tt_chuyen_di_dv_to_chuc_tour"
										:userSetting="userSettings"
										:data-vv-as="'Đơn vị tổ chức tour'"
										:placeholder="'Nhập Đơn vị tổ chức tour'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- thong tin cung cap dich vu y te -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">THÔNG TIN ĐƠN VỊ CUNG CẤP DỊCH VỤ Y TẾ</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Tên bệnh viện:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="ttdv_ten_benh_vien"
										name="ttdv_ten_benh_vien"
										:userSetting="userSettings"
										:data-vv-as="'Tên bệnh viện'"
										:placeholder="'Nhập Tên bệnh viện'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Mã số khách hàng tại bệnh viện:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="ttdv_mskh_benh_vien"
										name="ttdv_mskh_benh_vien"
										:userSetting="userSettings"
										:data-vv-as="'Mã số khách hàng tại bệnh viện'"
										:placeholder="'Nhập Mã số khách hàng tại bệnh viện'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- thong tin lich su y te -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">THÔNG TIN LỊCH SỬ Y TẾ</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Lịch sử y tế:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="lich_su_y_te"
										name="lich_su_y_te"
										:userSetting="userSettings"
										:data-vv-as="'Lịch sử y tế'"
										:placeholder="'Nhập Lịch sử y tế (nếu có)'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<!-- Issue Date -->
							<div class="deadline my-5">
								<label for class="vs-input--label">Ngày khám sức khỏe:</label>

								<vx-input-group>
									<template slot="append">
										<div class="append-text text-black">
											<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
										</div>
									</template>

									<cbs-date-picker readonly
										clearable
										class="w-full"
										type="date"
										name="ngay_kham_suc_khoe"
										prefix-icon="''"
										ref="issueDatePickerRef"
										format="DD-MM-yyyy"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="$t('IssueDate')"
										:placeholder="'Chọn Ngày khám sức khỏe'"
										v-model="ngay_kham_suc_khoe"
									/>
								</vx-input-group>
								<span class="text-danger text-sm break-normal" v-show="errors.has('start-date')">{{ errors.first("start-date") }}</span>
							</div>

							<div class="mt-5">
								<label for class="vs-input--label">Tên bác sĩ khám tổng quát:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="ttdv_ten_bac_si_tong_quat"
										name="ttdv_ten_bac_si_tong_quat"
										:userSetting="userSettings"
										:data-vv-as="'Tên bác sĩ khám tổng quát'"
										:placeholder="'Nhập Tên bác sĩ khám tổng quát'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Tên thông dịch viên:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="ttdv_ten_thong_dich_vien"
										name="ttdv_ten_thong_dich_vien"
										:userSetting="userSettings"
										:data-vv-as="'Tên thông dịch viên'"
										:placeholder="'Nhập Tên thông dịch viên'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				
				<!-- ket qua kiem tra the chat -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra thể chất</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_the_chat"
										name="kqkt_the_chat"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_the_chat_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_the_chat_images" name="kqkt_the_chat_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				
				<!-- ket qua kiem tra co -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra cổ</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_co"
										name="kqkt_co"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_co_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_co_images" name="kqkt_co_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				
				<!-- ket qua kiem tra tai mui hong -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra tai mũi họng</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_tai_mui_hong"
										name="kqkt_tai_mui_hong"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_tai_mui_hong_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_tai_mui_hong_images" name="kqkt_tai_mui_hong_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				
				<!-- ket qua kiem tra he than kinh -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra hệ thần kinh</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_he_than_kinh"
										name="kqkt_he_than_kinh"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_he_than_kinh_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_he_than_kinh_images" name="kqkt_he_than_kinh_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- ket qua xet nghiem -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả xét nghiệm</h6>
						</template>
						<div class="pl-6 pr-6" style="padding-top: 10px;">
							<!-- ket qua xet nghiem mau -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Máu</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Kết quả:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kqxn_mau"
													name="kqxn_mau"
													:userSetting="userSettings"
													:data-vv-as="'Kết quả'"
													:placeholder="'Nhập Kết quả'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kqxn_mau_images" class="vs-input--label directive--label">Hình ảnh:</label>
												<cbs-upload-ref :isEditable="false" v-model="kqxn_mau_images" name="kqxn_mau_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- ket qua xet nghiem nuoc tieu -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Nước tiểu</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Kết quả:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kqxn_nuoc_tieu"
													name="kqxn_nuoc_tieu"
													:userSetting="userSettings"
													:data-vv-as="'Kết quả'"
													:placeholder="'Nhập Kết quả'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kqxn_nuoc_tieu_images" class="vs-input--label directive--label">Hình ảnh:</label>
												<cbs-upload-ref :isEditable="false" v-model="kqxn_nuoc_tieu_images" name="kqxn_nuoc_tieu_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- ket qua xet nghiem phan -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Phân</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Kết quả:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kqxn_phan"
													name="kqxn_phan"
													:userSetting="userSettings"
													:data-vv-as="'Kết quả'"
													:placeholder="'Nhập Kết quả'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kqxn_phan_images" class="vs-input--label directive--label">Hình ảnh:</label>
												<cbs-upload-ref :isEditable="false" v-model="kqxn_phan_images" name="kqxn_phan_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq do dien tam do -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả Đo điện tâm đồ (EGC)</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả Đo điện tâm đồ (EGC):</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kq_do_dien_tam_do"
										name="kq_do_dien_tam_do"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả Đo điện tâm đồ (EGC)'"
										:placeholder="'Nhập Kết quả Đo điện tâm đồ (EGC)'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
									<label for="kq_do_dien_tam_do_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kq_do_dien_tam_do_images" name="kq_do_dien_tam_do_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq chup xquang -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết qua chụp X Quang</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết qua chụp X Quang:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kq_chup_xquang"
										name="kq_chup_xquang"
										:userSetting="userSettings"
										:data-vv-as="'Kết qua chụp X Quang'"
										:placeholder="'Nhập Kết qua chụp X Quang'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
									<label for="kq_chup_xquang_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kq_chup_xquang_images" name="kq_chup_xquang_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq kt mat do xuong -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra mật độ xương</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả kiểm tra mật độ xương:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_mat_do_xuong"
										name="kqkt_mat_do_xuong"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả kiểm tra mật độ xương'"
										:placeholder="'Nhập Kết quả kiểm tra mật độ xương'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_mat_do_xuong_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_mat_do_xuong_images" name="kqkt_mat_do_xuong_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq sieu am tong quat bung -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả Siêu âm tổng quát bụng</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả Siêu âm tổng quát bụng:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kq_sieu_am_tong_quat_bung"
										name="kq_sieu_am_tong_quat_bung"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả Siêu âm tổng quát bụng'"
										:placeholder="'Nhập Kết quả Siêu âm tổng quát bụng'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kq_sieu_am_tong_quat_bung_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kq_sieu_am_tong_quat_bung_images" name="kq_sieu_am_tong_quat_bung_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq kt nguc -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả kiểm tra ngực</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả kiểm tra ngực:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_nguc"
										name="kqkt_nguc"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_nguc_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_nguc_images" name="kqkt_nguc_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq kt kham phu khoa -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả Khám phụ khoa</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả Khám phụ khoa:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kq_kham_phu_khoa"
										name="kq_kham_phu_khoa"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kq_kham_phu_khoa_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kq_kham_phu_khoa_images" name="kq_kham_phu_khoa_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kq kt tuyen tien liet -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết quả Tuyến tiền liệt</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết quả Tuyến tiền liệt:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="kqkt_tuyen_tien_liet"
										name="kqkt_tuyen_tien_liet"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="kqkt_tuyen_tien_liet_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="kqkt_tuyen_tien_liet_images" name="kqkt_tuyen_tien_liet_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kl bs tong quat -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Kết luận của bác sĩ tổng quát</h6>
						</template>
						<div class="pl-6 pr-6">
							<div class="mt-5">
								<label for class="vs-input--label">Kết luận của bác sĩ tổng quát:</label>
									<cbs-input readonly
										dataType="text"
										class="vs-inputx vs-input--input normal w-full"
										v-model="klbs_tong_quat"
										name="klbs_tong_quat"
										:userSetting="userSettings"
										:data-vv-as="'Kết quả'"
										:placeholder="'Nhập Kết quả'"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="klbs_tong_quat_images" class="vs-input--label directive--label">Hình ảnh:</label>
									<cbs-upload-ref :isEditable="false" v-model="klbs_tong_quat_images" name="klbs_tong_quat_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for="klbs_tong_quat_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
									<cbs-upload-ref :isEditable="false" v-model="klbs_tong_quat_toa_thuoc_images" name="klbs_tong_quat_toa_thuoc_images" accept="image/*" />
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
							<div class="mt-5">
								<label for class="vs-input--label">Ngày tái khám:</label>
									<cbs-date-picker readonly
										clearable
										class="w-full"
										type="date"
										name="klbs_tong_quat_ngay_tai_kham"
										prefix-icon="''"
										ref="klbs_tong_quat_ngay_tai_kham"
										format="DD-MM-yyyy"
										value-format="yyyy-MM-dd HH:mm:ss"
										:data-vv-as="'Ngày tái khám'"
										:placeholder="'Ngày tái khám'"
										v-model="klbs_tong_quat_ngay_tai_kham"
									/>
								<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- kham sk ck -->
				<el-collapse class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">Khám sức khỏe chuyên khoa</h6>
						</template>
						<div class="pl-6 pr-6" style="padding-top: 10px;">
							<!-- kham sk ck1 -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Khám chuyên khoa 1</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Tên chuyên khoa:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck1_ten_chuyen_khoa"
													name="kham_ck1_ten_chuyen_khoa"
													:userSetting="userSettings"
													:data-vv-as="'Tên chuyên khoa'"
													:placeholder="'Nhập Tên chuyên khoa'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Lịch sử y tế:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck1_lich_su_y_te"
													name="kham_ck1_lich_su_y_te"
													:userSetting="userSettings"
													:data-vv-as="'Lịch sử y tế'"
													:placeholder="'Nhập Lịch sử y tế'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="date"
													name="kham_ck1_ngay_kham"
													prefix-icon="''"
													ref="kham_ck1_ngay_kham"
													format="DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày khám'"
													:placeholder="'Ngày khám'"
													v-model="kham_ck1_ngay_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck1_ket_qua_images" class="vs-input--label directive--label">Kết quả:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck1_ket_qua_images" name="kham_ck1_ket_qua_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Kết luận bác sĩ:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck1_kl_bs"
													name="kham_ck1_kl_bs"
													:userSetting="userSettings"
													:data-vv-as="'Kết luận bác sĩ'"
													:placeholder="'Nhập Kết luận bác sĩ'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck1_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck1_toa_thuoc_images" name="kham_ck1_toa_thuoc_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck1_ngay_hen_tai_kham"
													prefix-icon="''"
													ref="kham_ck1_ngay_hen_tai_kham"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck1_ngay_hen_tai_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck1_ngay_hen_tai_kham2"
													prefix-icon="''"
													ref="kham_ck1_ngay_hen_tai_kham2"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck1_ngay_hen_tai_kham2"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck1_ngay_hen_tai_kham3"
													prefix-icon="''"
													ref="kham_ck1_ngay_hen_tai_kham3"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck1_ngay_hen_tai_kham3"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Tên thông dịch viên:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck1_ten_thong_dich_vien"
													name="kham_ck1_ten_thong_dich_vien"
													:userSetting="userSettings"
													:data-vv-as="'Tên thông dịch viên'"
													:placeholder="'Nhập Tên thông dịch viên'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- kham sk ck2 -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Khám chuyên khoa 2</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Tên chuyên khoa:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck2_ten_chuyen_khoa"
													name="kham_ck2_ten_chuyen_khoa"
													:userSetting="userSettings"
													:data-vv-as="'Tên chuyên khoa'"
													:placeholder="'Nhập Tên chuyên khoa'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Lịch sử y tế:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck2_lich_su_y_te"
													name="kham_ck2_lich_su_y_te"
													:userSetting="userSettings"
													:data-vv-as="'Lịch sử y tế'"
													:placeholder="'Nhập Lịch sử y tế'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="date"
													name="kham_ck2_ngay_kham"
													prefix-icon="''"
													ref="kham_ck2_ngay_kham"
													format="DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày khám'"
													:placeholder="'Ngày khám'"
													v-model="kham_ck2_ngay_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck2_ket_qua_images" class="vs-input--label directive--label">Kết quả:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck2_ket_qua_images" name="kham_ck2_ket_qua_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Kết luận bác sĩ:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck2_kl_bs"
													name="kham_ck2_kl_bs"
													:userSetting="userSettings"
													:data-vv-as="'Kết luận bác sĩ'"
													:placeholder="'Nhập Kết luận bác sĩ'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck2_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck2_toa_thuoc_images" name="kham_ck2_toa_thuoc_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck2_ngay_hen_tai_kham"
													prefix-icon="''"
													ref="kham_ck2_ngay_hen_tai_kham"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck2_ngay_hen_tai_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck2_ngay_hen_tai_kham2"
													prefix-icon="''"
													ref="kham_ck2_ngay_hen_tai_kham2"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck2_ngay_hen_tai_kham2"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck2_ngay_hen_tai_kham3"
													prefix-icon="''"
													ref="kham_ck2_ngay_hen_tai_kham3"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck2_ngay_hen_tai_kham3"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Tên thông dịch viên:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck2_ten_thong_dich_vien"
													name="kham_ck2_ten_thong_dich_vien"
													:userSetting="userSettings"
													:data-vv-as="'Tên thông dịch viên'"
													:placeholder="'Nhập Tên thông dịch viên'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- kham sk ck3 -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Khám chuyên khoa 3</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Tên chuyên khoa:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck3_ten_chuyen_khoa"
													name="kham_ck3_ten_chuyen_khoa"
													:userSetting="userSettings"
													:data-vv-as="'Tên chuyên khoa'"
													:placeholder="'Nhập Tên chuyên khoa'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Lịch sử y tế:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck3_lich_su_y_te"
													name="kham_ck3_lich_su_y_te"
													:userSetting="userSettings"
													:data-vv-as="'Lịch sử y tế'"
													:placeholder="'Nhập Lịch sử y tế'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="date"
													name="kham_ck3_ngay_kham"
													prefix-icon="''"
													ref="kham_ck3_ngay_kham"
													format="DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày khám'"
													:placeholder="'Ngày khám'"
													v-model="kham_ck3_ngay_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck3_ket_qua_images" class="vs-input--label directive--label">Kết quả:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck3_ket_qua_images" name="kham_ck3_ket_qua_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Kết luận bác sĩ:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck3_kl_bs"
													name="kham_ck3_kl_bs"
													:userSetting="userSettings"
													:data-vv-as="'Kết luận bác sĩ'"
													:placeholder="'Nhập Kết luận bác sĩ'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck3_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck3_toa_thuoc_images" name="kham_ck3_toa_thuoc_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck3_ngay_hen_tai_kham"
													prefix-icon="''"
													ref="kham_ck3_ngay_hen_tai_kham"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck3_ngay_hen_tai_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck3_ngay_hen_tai_kham2"
													prefix-icon="''"
													ref="kham_ck3_ngay_hen_tai_kham2"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck3_ngay_hen_tai_kham2"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck3_ngay_hen_tai_kham3"
													prefix-icon="''"
													ref="kham_ck3_ngay_hen_tai_kham3"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck3_ngay_hen_tai_kham3"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Tên thông dịch viên:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck3_ten_thong_dich_vien"
													name="kham_ck3_ten_thong_dich_vien"
													:userSetting="userSettings"
													:data-vv-as="'Tên thông dịch viên'"
													:placeholder="'Nhập Tên thông dịch viên'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- kham sk ck4 -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Khám chuyên khoa 4</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Tên chuyên khoa:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck4_ten_chuyen_khoa"
													name="kham_ck4_ten_chuyen_khoa"
													:userSetting="userSettings"
													:data-vv-as="'Tên chuyên khoa'"
													:placeholder="'Nhập Tên chuyên khoa'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Lịch sử y tế:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck4_lich_su_y_te"
													name="kham_ck4_lich_su_y_te"
													:userSetting="userSettings"
													:data-vv-as="'Lịch sử y tế'"
													:placeholder="'Nhập Lịch sử y tế'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="date"
													name="kham_ck4_ngay_kham"
													prefix-icon="''"
													ref="kham_ck4_ngay_kham"
													format="DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày khám'"
													:placeholder="'Ngày khám'"
													v-model="kham_ck4_ngay_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck4_ket_qua_images" class="vs-input--label directive--label">Kết quả:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck4_ket_qua_images" name="kham_ck4_ket_qua_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Kết luận bác sĩ:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck4_kl_bs"
													name="kham_ck4_kl_bs"
													:userSetting="userSettings"
													:data-vv-as="'Kết luận bác sĩ'"
													:placeholder="'Nhập Kết luận bác sĩ'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck4_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck4_toa_thuoc_images" name="kham_ck4_toa_thuoc_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck4_ngay_hen_tai_kham"
													prefix-icon="''"
													ref="kham_ck4_ngay_hen_tai_kham"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck4_ngay_hen_tai_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck4_ngay_hen_tai_kham2"
													prefix-icon="''"
													ref="kham_ck4_ngay_hen_tai_kham2"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck4_ngay_hen_tai_kham2"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck4_ngay_hen_tai_kham3"
													prefix-icon="''"
													ref="kham_ck4_ngay_hen_tai_kham3"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck4_ngay_hen_tai_kham3"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Tên thông dịch viên:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck4_ten_thong_dich_vien"
													name="kham_ck4_ten_thong_dich_vien"
													:userSetting="userSettings"
													:data-vv-as="'Tên thông dịch viên'"
													:placeholder="'Nhập Tên thông dịch viên'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>

							<!-- kham sk ck5 -->
							<el-collapse class="cbs-collapse mt-0">
								<el-collapse-item name="GeneralInfo">
									<template slot="title">
										<h6 class="uppercase font-bold ml-6">Khám chuyên khoa 5</h6>
									</template>
									<div class="pl-6 pr-6">
										<div class="mt-5">
											<label for class="vs-input--label">Tên chuyên khoa:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck5_ten_chuyen_khoa"
													name="kham_ck5_ten_chuyen_khoa"
													:userSetting="userSettings"
													:data-vv-as="'Tên chuyên khoa'"
													:placeholder="'Nhập Tên chuyên khoa'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Lịch sử y tế:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck5_lich_su_y_te"
													name="kham_ck5_lich_su_y_te"
													:userSetting="userSettings"
													:data-vv-as="'Lịch sử y tế'"
													:placeholder="'Nhập Lịch sử y tế'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="date"
													name="kham_ck5_ngay_kham"
													prefix-icon="''"
													ref="kham_ck5_ngay_kham"
													format="DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày khám'"
													:placeholder="'Ngày khám'"
													v-model="kham_ck5_ngay_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck5_ket_qua_images" class="vs-input--label directive--label">Kết quả:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck5_ket_qua_images" name="kham_ck5_ket_qua_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Kết luận bác sĩ:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck5_kl_bs"
													name="kham_ck5_kl_bs"
													:userSetting="userSettings"
													:data-vv-as="'Kết luận bác sĩ'"
													:placeholder="'Nhập Kết luận bác sĩ'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for="kham_ck5_toa_thuoc_images" class="vs-input--label directive--label">Toa thuốc:</label>
												<cbs-upload-ref :isEditable="false" v-model="kham_ck5_toa_thuoc_images" name="kham_ck5_toa_thuoc_images" accept="image/*" />
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck5_ngay_hen_tai_kham"
													prefix-icon="''"
													ref="kham_ck5_ngay_hen_tai_kham"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck5_ngay_hen_tai_kham"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck5_ngay_hen_tai_kham2"
													prefix-icon="''"
													ref="kham_ck5_ngay_hen_tai_kham2"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck5_ngay_hen_tai_kham2"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Ngày hẹn tái khám:</label>
												<cbs-date-picker readonly
													clearable
													class="w-full"
													type="datetime"
													name="kham_ck5_ngay_hen_tai_kham3"
													prefix-icon="''"
													ref="kham_ck5_ngay_hen_tai_kham3"
													format="HH:mm DD-MM-yyyy"
													value-format="yyyy-MM-dd HH:mm:ss"
													:data-vv-as="'Ngày hẹn tái khám'"
													:placeholder="'Ngày hẹn tái khám'"
													v-model="kham_ck5_ngay_hen_tai_kham3"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
										<div class="mt-5">
											<label for class="vs-input--label">Tên thông dịch viên:</label>
												<cbs-input readonly
													dataType="text"
													class="vs-inputx vs-input--input normal w-full"
													v-model="kham_ck5_ten_thong_dich_vien"
													name="kham_ck5_ten_thong_dich_vien"
													:userSetting="userSettings"
													:data-vv-as="'Tên thông dịch viên'"
													:placeholder="'Nhập Tên thông dịch viên'"
												/>
											<span class="text-danger text-sm break-normal" v-show="errors.has('amount')">{{ errors.first("amount") }}</span>
										</div>
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</perfect-scrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button :type="'border'" class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" @click.stop="submitData(false)">
				{{ $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import CbsUploadRef from "@/components/cbs-upload-ref/CbsUploadRef";
import moment from "moment";

export default {
	name: "CustomerTTYTDetail",
	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		},
		infoData: {
			type: Object,
			default: () => {}
		},
		debtFormTitle: {
			type: String,
			default: "CreateDebt"
		}
	},
	components: {
		vSelect, CbsUploadRef
	},
	data() {
		return {
			id: null,
			tt_chuyen_di_ma:null,
			tt_chuyen_di_dv_to_chuc_tour:null,
			ttdv_ten_benh_vien:null,
			ttdv_mskh_benh_vien:null,
			lich_su_y_te:null,
			ttdv_ten_bac_si_tong_quat:null,
			ttdv_ten_thong_dich_vien:null,
			kqkt_the_chat:null,
			kqkt_co:null,
			kqkt_tai_mui_hong:null,
			kqkt_he_than_kinh:null,
			kqxn_mau:null,
			kqxn_nuoc_tieu:null,
			kqxn_phan:null,
			kq_do_dien_tam_do:null,
			kq_chup_xquang:null,
			kqkt_mat_do_xuong:null,
			kq_sieu_am_tong_quat_bung:null,
			kqkt_nguc:null,
			kq_kham_phu_khoa:null,
			kqkt_tuyen_tien_liet:null,
			klbs_tong_quat:null,
			kham_ck1_ten_chuyen_khoa:null,
			kham_ck1_lich_su_y_te:null,
			kham_ck1_kl_bs:null,
			kham_ck1_ten_thong_dich_vien:null,
			kham_ck2_ten_chuyen_khoa:null,
			kham_ck2_lich_su_y_te:null,
			kham_ck2_kl_bs:null,
			kham_ck2_ten_thong_dich_vien:null,
			kham_ck3_ten_chuyen_khoa:null,
			kham_ck3_lich_su_y_te:null,
			kham_ck3_kl_bs:null,
			kham_ck3_ten_thong_dich_vien:null,
			kham_ck4_ten_chuyen_khoa:null,
			kham_ck4_lich_su_y_te:null,
			kham_ck4_kl_bs:null,
			kham_ck4_ten_thong_dich_vien:null,
			kham_ck5_ten_chuyen_khoa:null,
			kham_ck5_lich_su_y_te:null,
			kham_ck5_kl_bs:null,
			kham_ck5_ten_thong_dich_vien:null,

			tt_chuyen_di_ngay_di:null,
			tt_chuyen_di_ngay_ve:null,
			ngay_kham_suc_khoe:null,
			klbs_tong_quat_ngay_tai_kham:null,
			kham_ck1_ngay_kham:null,
			kham_ck1_ngay_hen_tai_kham:null,
			kham_ck1_ngay_hen_tai_kham2:null,
			kham_ck1_ngay_hen_tai_kham3:null,
			kham_ck2_ngay_kham:null,
			kham_ck2_ngay_hen_tai_kham:null,
			kham_ck2_ngay_hen_tai_kham2:null,
			kham_ck2_ngay_hen_tai_kham3:null,
			kham_ck3_ngay_kham:null,
			kham_ck3_ngay_hen_tai_kham:null,
			kham_ck3_ngay_hen_tai_kham2:null,
			kham_ck3_ngay_hen_tai_kham3:null,
			kham_ck4_ngay_kham:null,
			kham_ck4_ngay_hen_tai_kham:null,
			kham_ck4_ngay_hen_tai_kham2:null,
			kham_ck4_ngay_hen_tai_kham3:null,
			kham_ck5_ngay_kham:null,
			kham_ck5_ngay_hen_tai_kham:null,
			kham_ck5_ngay_hen_tai_kham2:null,
			kham_ck5_ngay_hen_tai_kham3:null,

			tt_chuyen_di_lich_trinh_images:null,
			kqkt_the_chat_images:null,
			kqkt_co_images:null,
			kqkt_tai_mui_hong_images:null,
			kqkt_he_than_kinh_images:null,
			kqxn_mau_images:null,
			kqxn_nuoc_tieu_images:null,
			kqxn_phan_images:null,
			kq_do_dien_tam_do_images:null,
			kq_chup_xquang_images:null,
			kqkt_mat_do_xuong_images:null,
			kq_sieu_am_tong_quat_bung_images:null,
			kqkt_nguc_images:null,
			kq_kham_phu_khoa_images:null,
			kqkt_tuyen_tien_liet_images:null,
			klbs_tong_quat_images:null,
			klbs_tong_quat_toa_thuoc_images:null,
			kham_ck1_ket_qua_images:null,
			kham_ck1_toa_thuoc_images:null,
			kham_ck2_ket_qua_images:null,
			kham_ck2_toa_thuoc_images:null,
			kham_ck3_ket_qua_images:null,
			kham_ck3_toa_thuoc_images:null,
			kham_ck4_ket_qua_images:null,
			kham_ck4_toa_thuoc_images:null,
			kham_ck5_ket_qua_images:null,
			kham_ck5_toa_thuoc_images:null,
			
			isFormDirty: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
			this.initValues();
		},
		data: function(newVal, oldVal) {
			if (_.isEmpty(newVal) || newVal.id !== oldVal.id) {
				this.$nextTick(() => {
					if (this.$refs.vueScrollBar) {
						this.$refs.vueScrollBar.$el.scrollTop = 0;
					}
				});
			}
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData);
			},
			deep: true
		},
		schedule_enable() {
			if (this.schedule_enable) {
				this.due_mode = 0;
			}
		}
	},

	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		computedFormData() {
			return {};
		},
		productsChoices() {
			return this.$store.state.customerManagement.showProducts;
		}
	},
	methods: {
		initValues() {
			this.deliveryCode = "";
			this.productId = "";
			this.issuedDate = "";
			this.amount = "";
			this.deadline = "";
			this.paid_days = "";
			this.isFormDirty = false;
			this.setInitFormData();
			this.$validator.reset();
		},
		setInitFormData() {
			this.$nextTick(() => {
				this.initFormData = {
					deliveryCode: this.deliveryCode,
					productId: this.productId,
					issuedDate: this.issuedDate,
					amount: this.amount,
					deadline: this.deadline
				};
			});
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: `Lưu ${this.$t("Successful")} `
				}
			});
		},
		async handleCreateOrUpdateCustomerDebt(dataObj, isCloseForm) {
			// console.log(dataObj); return;
			try {
				this.$vs.loading();
				let response;

				response = await this.$store.dispatch("customerManagement/saveCustomerTTYT", dataObj);
				// console.log(response);

				// if (response) {
					// this.$emit("onCreateOrUpdateSuccess", response.id);
				// }
				// this.$store.dispatch("customerManagement/increaseTotalDebts");
				// await this.$store.dispatch("customerManagement/getCustomerDetail", {
				// 	id: this.data.id
				// });

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					try {
						const dataObj = {
							data: this.data,
							info: {
								id:this.id,
								tt_chuyen_di_ma:this.tt_chuyen_di_ma,
								tt_chuyen_di_dv_to_chuc_tour:this.tt_chuyen_di_dv_to_chuc_tour,
								ttdv_ten_benh_vien:this.ttdv_ten_benh_vien,
								ttdv_mskh_benh_vien:this.ttdv_mskh_benh_vien,
								lich_su_y_te:this.lich_su_y_te,
								ttdv_ten_bac_si_tong_quat:this.ttdv_ten_bac_si_tong_quat,
								ttdv_ten_thong_dich_vien:this.ttdv_ten_thong_dich_vien,
								kqkt_the_chat:this.kqkt_the_chat,
								kqkt_co:this.kqkt_co,
								kqkt_tai_mui_hong:this.kqkt_tai_mui_hong,
								kqkt_he_than_kinh:this.kqkt_he_than_kinh,
								kqxn_mau:this.kqxn_mau,
								kqxn_nuoc_tieu:this.kqxn_nuoc_tieu,
								kqxn_phan:this.kqxn_phan,
								kq_do_dien_tam_do:this.kq_do_dien_tam_do,
								kq_chup_xquang:this.kq_chup_xquang,
								kqkt_mat_do_xuong:this.kqkt_mat_do_xuong,
								kq_sieu_am_tong_quat_bung:this.kq_sieu_am_tong_quat_bung,
								kqkt_nguc:this.kqkt_nguc,
								kq_kham_phu_khoa:this.kq_kham_phu_khoa,
								kqkt_tuyen_tien_liet:this.kqkt_tuyen_tien_liet,
								klbs_tong_quat:this.klbs_tong_quat,
								kham_ck1_ten_chuyen_khoa:this.kham_ck1_ten_chuyen_khoa,
								kham_ck1_lich_su_y_te:this.kham_ck1_lich_su_y_te,
								kham_ck1_kl_bs:this.kham_ck1_kl_bs,
								kham_ck1_ten_thong_dich_vien:this.kham_ck1_ten_thong_dich_vien,
								kham_ck2_ten_chuyen_khoa:this.kham_ck2_ten_chuyen_khoa,
								kham_ck2_lich_su_y_te:this.kham_ck2_lich_su_y_te,
								kham_ck2_kl_bs:this.kham_ck2_kl_bs,
								kham_ck2_ten_thong_dich_vien:this.kham_ck2_ten_thong_dich_vien,
								kham_ck3_ten_chuyen_khoa:this.kham_ck3_ten_chuyen_khoa,
								kham_ck3_lich_su_y_te:this.kham_ck3_lich_su_y_te,
								kham_ck3_kl_bs:this.kham_ck3_kl_bs,
								kham_ck3_ten_thong_dich_vien:this.kham_ck3_ten_thong_dich_vien,
								kham_ck4_ten_chuyen_khoa:this.kham_ck4_ten_chuyen_khoa,
								kham_ck4_lich_su_y_te:this.kham_ck4_lich_su_y_te,
								kham_ck4_kl_bs:this.kham_ck4_kl_bs,
								kham_ck4_ten_thong_dich_vien:this.kham_ck4_ten_thong_dich_vien,
								kham_ck5_ten_chuyen_khoa:this.kham_ck5_ten_chuyen_khoa,
								kham_ck5_lich_su_y_te:this.kham_ck5_lich_su_y_te,
								kham_ck5_kl_bs:this.kham_ck5_kl_bs,
								kham_ck5_ten_thong_dich_vien:this.kham_ck5_ten_thong_dich_vien,

								tt_chuyen_di_ngay_di:this.tt_chuyen_di_ngay_di,
								tt_chuyen_di_ngay_ve:this.tt_chuyen_di_ngay_ve,
								ngay_kham_suc_khoe:this.ngay_kham_suc_khoe,
								klbs_tong_quat_ngay_tai_kham:this.klbs_tong_quat_ngay_tai_kham,
								kham_ck1_ngay_kham:this.kham_ck1_ngay_kham,
								kham_ck1_ngay_hen_tai_kham:this.kham_ck1_ngay_hen_tai_kham,
								kham_ck1_ngay_hen_tai_kham2:this.kham_ck1_ngay_hen_tai_kham2,
								kham_ck1_ngay_hen_tai_kham3:this.kham_ck1_ngay_hen_tai_kham3,
								kham_ck2_ngay_kham:this.kham_ck2_ngay_kham,
								kham_ck2_ngay_hen_tai_kham:this.kham_ck2_ngay_hen_tai_kham,
								kham_ck2_ngay_hen_tai_kham2:this.kham_ck2_ngay_hen_tai_kham2,
								kham_ck2_ngay_hen_tai_kham3:this.kham_ck2_ngay_hen_tai_kham3,
								kham_ck3_ngay_kham:this.kham_ck3_ngay_kham,
								kham_ck3_ngay_hen_tai_kham:this.kham_ck3_ngay_hen_tai_kham,
								kham_ck3_ngay_hen_tai_kham2:this.kham_ck3_ngay_hen_tai_kham2,
								kham_ck3_ngay_hen_tai_kham3:this.kham_ck3_ngay_hen_tai_kham3,
								kham_ck4_ngay_kham:this.kham_ck4_ngay_kham,
								kham_ck4_ngay_hen_tai_kham:this.kham_ck4_ngay_hen_tai_kham,
								kham_ck4_ngay_hen_tai_kham2:this.kham_ck4_ngay_hen_tai_kham2,
								kham_ck4_ngay_hen_tai_kham3:this.kham_ck4_ngay_hen_tai_kham3,
								kham_ck5_ngay_kham:this.kham_ck5_ngay_kham,
								kham_ck5_ngay_hen_tai_kham:this.kham_ck5_ngay_hen_tai_kham,
								kham_ck5_ngay_hen_tai_kham2:this.kham_ck5_ngay_hen_tai_kham2,
								kham_ck5_ngay_hen_tai_kham3:this.kham_ck5_ngay_hen_tai_kham3,

								tt_chuyen_di_lich_trinh_images:this.tt_chuyen_di_lich_trinh_images,
								kqkt_the_chat_images:this.kqkt_the_chat_images,
								kqkt_co_images:this.kqkt_co_images,
								kqkt_tai_mui_hong_images:this.kqkt_tai_mui_hong_images,
								kqkt_he_than_kinh_images:this.kqkt_he_than_kinh_images,
								kqxn_mau_images:this.kqxn_mau_images,
								kqxn_nuoc_tieu_images:this.kqxn_nuoc_tieu_images,
								kqxn_phan_images:this.kqxn_phan_images,
								kq_do_dien_tam_do_images:this.kq_do_dien_tam_do_images,
								kq_chup_xquang_images:this.kq_chup_xquang_images,
								kqkt_mat_do_xuong_images:this.kqkt_mat_do_xuong_images,
								kq_sieu_am_tong_quat_bung_images:this.kq_sieu_am_tong_quat_bung_images,
								kqkt_nguc_images:this.kqkt_nguc_images,
								kq_kham_phu_khoa_images:this.kq_kham_phu_khoa_images,
								kqkt_tuyen_tien_liet_images:this.kqkt_tuyen_tien_liet_images,
								klbs_tong_quat_images:this.klbs_tong_quat_images,
								klbs_tong_quat_toa_thuoc_images:this.klbs_tong_quat_toa_thuoc_images,
								kham_ck1_ket_qua_images:this.kham_ck1_ket_qua_images,
								kham_ck1_toa_thuoc_images:this.kham_ck1_toa_thuoc_images,
								kham_ck2_ket_qua_images:this.kham_ck2_ket_qua_images,
								kham_ck2_toa_thuoc_images:this.kham_ck2_toa_thuoc_images,
								kham_ck3_ket_qua_images:this.kham_ck3_ket_qua_images,
								kham_ck3_toa_thuoc_images:this.kham_ck3_toa_thuoc_images,
								kham_ck4_ket_qua_images:this.kham_ck4_ket_qua_images,
								kham_ck4_toa_thuoc_images:this.kham_ck4_toa_thuoc_images,
								kham_ck5_ket_qua_images:this.kham_ck5_ket_qua_images,
								kham_ck5_toa_thuoc_images:this.kham_ck5_toa_thuoc_images,
							}
						};

						let finalData = {
							data: JSON.stringify(dataObj.data),
							info: JSON.stringify(dataObj.info)
						};
						this.handleCreateOrUpdateCustomerDebt(finalData, isCloseForm);
					} catch (error) {
						console.error(error);
					}
				}
			});
		},
		triggerClickDatetimePicker() {
			this.$refs.issueDatePickerRef.$children[0].pickerVisible = true;
		},
		fetchOptions(search, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				if (!loading) {
					loading = this.$refs[this.ref] && this.$refs[this.ref].toggleLoading;
				}

				loading(true);
				try {
					await this.fetchProducts(search);
					loading(false);
				} catch (error) {
					loading(false);
				}
			}, 400);
		},
		async fetchProducts(search = "") {
			const payload = { search: search, limit: 15, page: 1 };
			await this.$store.dispatch("customerManagement/fetchCustomerShowProducts", payload);
		}
	},
	created() {
		// this.fetchProducts("a");
		// console.log('this.infoData: ', this.infoData);
		if (this.infoData && this.infoData.info) {
			for (let k in this.infoData.info) {
				let info = this.infoData.info[k];
				this[k] = info;
				console.log(k, info);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.vs-input--input {
	padding:0 !important;
	border: none !important;
}
</style>